import React from 'react';
import img3 from '../../assets/logos/img3.png';

import './Modal.css';

const Modal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <div className="profile-modal1-left">
            <img src={img3} alt="img3" className="profile-modal1-img" />
          </div>
          <div className="profile-right">
            <div class="cv-section">
              <h2>Nos especializamos en:</h2>

              <h3>Gestión Integral de Inversiones Inmobiliarias</h3>
              <ul>
                <li>Evaluación estratégica del mercado: identificación de propiedades con alto potencial en Dubái.</li>
                <li>Orientación personalizada para maximizar rentabilidad y minimizar riesgos.</li>
                <li>Supervisión de portafolios diversificados para garantizar estabilidad financiera a largo plazo.</li>
              </ul>

              <h3>Consultoría Estratégica Jurídica Inmobiliaria</h3>
              <ul>
                <li>Redacción y revisión de contratos de compraventa y arrendamiento, asegurando transparencia.</li>
                <li>Asesoramiento en normativas legales locales e internacionales sobre transacciones inmobiliarias.</li>
                <li>Gestión de documentación legal para compradores e inversores extranjeros.</li>
              </ul>

              <h3>Networking Internacional</h3>
              <ul>
                <li>Conexiones globales con inversores y profesionales clave del mercado inmobiliario.</li>
                <li>Generación de nuevas oportunidades de negocio mediante alianzas estratégicas.</li>
                <li>Facilitación de contactos en mercados internacionales para desarrolladores e inversores.</li>
              </ul>

              <h3>Soporte Estratégico para Fondos Comunes de Inversión</h3>
              <ul>
                <li>Creación de estructuras financieras sólidas para proyectos inmobiliarios.</li>
                <li>Coordinación con consultores financieros y legales en la formación de fondos de inversión.</li>
                <li>Evaluación de aspectos legales y financieros para maximizar la rentabilidad.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
